import { getStrapiApollo } from "../constants/uri";
import gql from "graphql-tag";

export class BlogService {
    apolloClient;

    constructor(apolloClient = null) {
        if (!apolloClient) {
            this.apolloClient = getStrapiApollo();
        } else {
            this.apolloClient = apolloClient;
        }
    }

    async fetchList() {
        const result = await this.apolloClient.query(
            {
                query: gql`
                    {
                        blogs {
                            id
                            title
                            subTitle
                            slug
                            ReadingTime
                            PublishDate
                            categories{
                                id
                                title
                            }
                            SEODescription
                            headerImage{url}
                            updated_at
                            isHero
                        }
                    }
                `
            }
        );

        return result.data.blogs;
    }

    async fetchDetail(slug) {
        const result = await this.apolloClient.query(
            {
                query: gql`{
                    blogs(where: { slug: "${slug}"  }) {
                        id
                        slug
                        title
                        subTitle
                        PublishDate
                        ReadingTime
                        isHero
                        categories{id}
                        content
                        SEODescription
                        SEOTitle
                        headerImage{url}
                        created_at
                        published_at
                        updated_at
                        lastUpdated
                        firebase_user {
                            firstname
                            avatar{url}
                        }
                        blogRelated{
                            blog {
                                id
                            }
                        }
                        recipeRelated{
                            recipe {
                                id
                            }
                        }
                        courseRelated{
                            course {
                                id
                            }
                        }
                      }
                    }
                `
            }
        );

        return result.data.blogs[0];
    }
}
